/* eslint-disable no-unreachable */
/* global initCookieConsent */

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
//import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Dropdown, Modal } from 'bootstrap'
import Mmenu from 'mmenu-js'
import Sharer from 'sharer.js'
import './mappa.js'
import { setupAjaxUtils, useAjaxAutoBrowserHistoryUpdate } from './ajax-utils'
import 'vanilla-cookieconsent';
import "vanilla-cookieconsent/dist/cookieconsent.css"
import '../scss/application.scss'


$(function () {
	// initialize ajax-utils
	setupAjaxUtils();
});


$(function () {
	$('.prestazioni-back').click(function () {
		var lastCliccableLink = $('li.breadcrumbs-item:has(a)').last();
		var link = lastCliccableLink.find('a').attr('href');
		window.location.href = link;
	});
});

/*
 * Init Mmenu.js
 */
$(function () {
	$(document).ready(function () {
		const mainMenu = new Mmenu("#main-menu", {
			"offCanvas": {
				"position": "right"
			},
			"theme": "white",
			navbar: {
				title: '<a href="/"><img id="logo-sanarti" src="/Content/img/logo-header.svg" alt="sanarti_logo" style="width:180px;"></a>',
			}
		});

		const api = mainMenu.API;

		api.bind("close:after",
			(panel) => {
				$('.menu-trigger').removeClass("is-active")
			}
		);
	})


})

/*
 * Toggle form di ricerca su desktop
 */
$(function () {
	$(".main-search-trigger").on("click", function (ev) {
		ev.preventDefault();
		$("body").addClass("main-search-open")
		$(".main-search-layer").addClass("open")
		$("#search-form input").focus();
	})

	$(".main-search-layer").on("click", function (ev) {
		if ($(ev.target).hasClass(".search-form") || $(ev.target).closest(".search-form").length) return;
		$("body").removeClass("main-search-open")
		$(".main-search-layer").removeClass("open")
	})

})


// Popup area riservata fuori servizio
$(function () {
	return true;
	const areaRiservataLink = $('a[href^="https://areariservata.sanarti.it"], a[href^="https://sportello.sanarti.it"]');
	const modalHtml = `<div class="modal fade" id="outOfService" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header bg-warning text-white">
					<h5 class="modal-title fs-4" id="outOfServiceLabel">Attenzione!</h5>
					<button title="Chiudi" type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body fs-4">
					I servizi on line non sono disponibili fino a lunedì mattina. Sono in corso attività di manutenzione all'Area riservata che pertanto non è accessibile.
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-warning text-white px-4" data-bs-dismiss="modal">Chiudi</button>
				</div>
			</div>
		</div>
	</div>`;
	areaRiservataLink.each((index, el) => {
		$(el).on("click", function (ev) {
			ev.preventDefault();
			if (!$("#outOfService").length) {
				$("body").append(modalHtml)
			}
			const outOfServiceModal = new Modal("#outOfService");
			outOfServiceModal.show();
			//$("#outOfService").modal("show")
		})
	})
});


/*
 * BG image parallax effect
 */

//$(function () {
//    let velocity = -0.5;
//    $(window).scroll(() => {
//        let pos = $(window).scrollTop();
//        $('.page-content-pattern-old').each(function () {
//            let $element = $(this);
//            let height = $element.height() - 18;
//            $(this).css('backgroundPosition', '30% ' + Math.round((height - pos) * velocity) + 'px');
//        });
//    })
//})

$(window).on('scroll', function () {
	var scrollPos = $(this).scrollTop();
	$('.page-content-pattern-old').css('backgroundPosition', '30% ' + scrollPos / 2 + 'px');
});

$(function () {
	let velocity = 0.1;
	$(window).scroll(() => {
		let pos = $(window).scrollTop() + 800;
		$('.home-content-pattern').each(function () {
			let $element = $(this);
			let height = $element.height() - 18;
			$(this).css('backgroundPosition', '30% ' + Math.round((height - pos) * velocity) + 'px');
		});
	})
})

/*
 * Fix 100vh issue on chrome 
 */

$(function () {
	if (window.innerWidth <= 991) return;
	$("#main-carousel").css({
		height: (window.innerHeight - $("header").height())
	})
})

/*
 * Fix 100vh issue on chrome 
 */

$(function () {
	$("#mainMenu .dropdown-item").on("click", function (ev) {
		if (window.innerWidth < 1200) ev.stopPropagation();
	})
})

/* Back to top button */

$(function () {

	$(document).scroll(function () {
		var y = $(this).scrollTop();
		if ($('#back-to-top').hasClass('disabled')) return;
		if (y >= $('header').height()) {
			$('#back-to-top').show();
		} else {
			$('#back-to-top').hide();
		}
	});

});




/*
 * Burger menu
 */

$(function () {

	$("button.hamburger").on("click", function (ev) {
		$(this).toggleClass("is-active")
	})
})


/*
 *  Main Carsouel
 */

$(function () {
	var swiper = new Swiper('#main-carousel', {
		modules: [Navigation, Pagination],
		autoHeight: true,
		loop: true,
		pagination: {
			el: $('#main-carousel').find('.swiper-pagination')[0],
			clickable: true,
		},
		autoplay: {
			/*delay: (location.hostname == "localhost" ? 5000000 : 5000),*/
			delay: 500000,
		},
		speed: 400,
		on: {
			init: function () {
				//console.log($('#main-carousel').find('.swiper-slide[data-swiper-slide-index=1] .swiper-slide-info *'))
				//setTimeout(() => {
				//	$('#main-carousel').find('.swiper-slide[data-swiper-slide-index=1] .swiper-slide-info *').css({ display: "block" });
				//}, 1000)

			},
			slideChange: function (swiper) {
				$('#main-carousel').find('.swiper-slide .swiper-slide-info *').hide();
				$('#main-carousel').find('.swiper-slide:eq(' + swiper.activeIndex + ') .swiper-slide-info *').show();
			}
		},
		breakpoints: {
			// when window width is >= Xpx
			992: {
				autoHeight: false
			}
		}
	});
})

$(document).ready(function () {
	var numOfSlides = $('.comefareper-swiper-container').find('.swiper-slide').length;

	var swiper = new Swiper(".comefareper-swiper-container", {
		modules: [Navigation],
		spaceBetween: 20,
		slidesPerView: 1.4,
		centeredSlides: false,
		navigation: {
			nextEl: '.swiper-comefareper-navigation .swiper-button-next',
			prevEl: '.swiper-comefareper-navigation .swiper-button-prev',
		},
		breakpoints: {
			470: {
				slidesPerView: 1.8,
			},
			768: {
				slidesPerView: 2.1,
			},
			800: {
				slidesPerView: 2.4,
			},
			992: {
				slidesPerView: 3.1,
			},
			1200: {
				slidesPerView: numOfSlides > 4 ? 4.1 : 4,
			},
		},
		on: {
			slideChange: function (swiper) {
				if (swiper.isBeginning) {
					swiper.slideTo(0);
				}
				if (swiper.isEnd) {
					swiper.slideTo(swiper.slides.length - 1);
				}
			},
		},
	});
});

/*
 *  Sottomenu prestazioni - landing-submenu
 */

$(function () {

	//$(".box-custom-nested").each(function () {
	//	var box = $(this).closest(".box-custom");
	//	box.css({ cursor: "pointer" });
	//	if (!$(this).find(".box-custom").length) {
	//		box.on("click", function () {
	//			location.href = box.find("> a").attr("href");
	//		})
	//		$(this).remove();
	//	}
	//})

	//$(".submenu-trigger").on("click", function (ev) {
	//	ev.preventDefault();
	//	var $this = $(this);
	//	if (!$this.closest(".submenu-trigger").find(".landing-submenu").length) {
	//		console.log("no submenu");
	//		return true;
	//	}
	//	$(".landing-submenu").fadeIn();
	//});

	$(document).ready(function () {
		$(document).on("click", ".submenu-trigger", function (ev) {
			var $this = $(this);
			var $submenu = $this.closest(".landing-button").find(".landing-submenu");

			if ($submenu.length === 0) {
				console.log("No submenu per questo elemento.");
				return;
			}

			ev.preventDefault();
			$(".landing-submenu").not($submenu).fadeOut();
			$submenu.fadeIn();
		});

		$(document).on("click", ".close-landing-submenu", function (ev) {
			ev.preventDefault();
			$(this).closest(".landing-submenu").fadeOut();
		});
	});



	//$(".close-landing-submenu").on("click", function (ev) {
	//    ev.preventDefault();
	//    const $this = $(this);
	//    const submenu = $this.closest("div").find(".landing-submenu");
	//    submenu.fadeOut();
	//});

	$(".close-landing-submenu").on("click", function (ev) {
		ev.preventDefault();
		const $this = $(this);
		const submenu = $(".landing-submenu");
		submenu.fadeOut();
	});

})


/*
 *  Breadcrumbs articolo/prestazione su mobile: gestito come una dropdown
 */

$(function () {
	$(".prestazione-article-template .breadcrumbs-list").on("click", function (ev) {
		var $this = $(this);
		$this.toggleClass("active");
	})
})

/*
 *  Table responsiveness
 */

$(function () {
	$(".article-body table").each(function () {
		$(this).wrap("<div class='table-responsive'></div>");

	})
})

/*
 *  Inizializzazione del fancybox 
*/

//$(function () {

//	Fancybox.bind(".gallery-trigger", {
//		groupAll: true,
//		l10n: {
//			CLOSE: "Chiudi",
//			NEXT: "Immagine successiva",
//			PREV: "Immagine precedente",
//			MODAL: "Puoi uscire dalla visualizzazione della gallery digitando ESC",
//			ERROR: "Si è verificato un errore imprevisto.",
//			IMAGE_ERROR: "Immagine non disponibile",
//			ELEMENT_NOT_FOUND: "HTML Element Not Found",
//			AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
//			AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
//			IFRAME_ERROR: "Error Loading Page",
//			TOGGLE_FULLSCREEN: "Attiva/disattiva la modalità full-screen",
//		}
//	});

//})

/* MODALE PRESTAZIONI */
$(document).ready(function () {
	let transformedElement = null;
	var cookieTab = $('#cookie-tab');
	var backToTop = $('#back-to-top');
	var iawTrigger = $('#iaw-trigger');

	// Show the modal when trigger button is clicked
	$('.modal-trigger').on('click', function () {
		var target = $(this).data('target');

		// Find the ancestor with transform applied (if any)
		transformedElement = $('*').filter(function () {
			return $(this).css('transform') !== 'none' && $(this).css('position') === 'relative';
		}).first();

		// Temporarily remove transform
		if (transformedElement) {
			transformedElement.css('transform', 'none');
		}

		$('#' + target).attr('aria-hidden', 'false').css('position', 'fixed');
		setTimeout(function () {
			$('#' + target).fadeIn();
			$('#cookie-tab').fadeOut();
			$('#back-to-top').fadeOut();
			$('#iaw-trigger').fadeOut();
			$('body').css('overflow-y', 'hidden');

		}, 300);
	});

	// Close modal on close button click
	$('.custom-modal-close').on('click', function () {
		var modal = $(this).closest('.custom-modal');
		modal.fadeOut(100);
		cookieTab.fadeIn();
		backToTop.fadeIn();
		iawTrigger.fadeIn();
		$('body').css('overflow-y', 'auto');

		setTimeout(function () {
			modal.attr('aria-hidden', 'true');

			// Restore transform
			if (transformedElement) {
				transformedElement.css('transform', '');
			}
		}, 1000);
	});

	// Close modal on overlay click
	$('.custom-modal-overlay').on('click', function () {
		var modal = $(this).closest('.custom-modal');
		modal.fadeOut(100);
		cookieTab.fadeIn();
		backToTop.fadeIn();
		iawTrigger.fadeIn();
		$('body').css('overflow-y', 'auto');

		setTimeout(function () {
			modal.attr('aria-hidden', 'true');

			// Restore transform
			if (transformedElement) {
				transformedElement.css('transform', '');
			}
		}, 1000);
	});

	// Ensure modals maintain position fixed when mmenu.js is toggled
	if (typeof $.mmenu !== 'undefined') {
		$(document).on('open.mm close.mm', function () {
			$('.custom-modal').each(function () {
				if ($(this).is(':visible')) {
					$(this).css('position', 'fixed');
				}
			});
		});
	}
});




/* Cookie directive */

$(function () {

	// IN SOSPESO FINO A NUOVE ISTRUZIONI DAL CLIENTE
	// return;

	const cookiePolicyUrl = $('body').data("cookie-policy-url");

	// obtain plugin
	var cc = initCookieConsent();

	// run plugin with your configuration
	cc.run({
		gui_options: {
			consent_modal: {
				layout: 'cloud',               // box/cloud/bar
				position: 'bottom center',     // bottom/middle/top + left/right/center
				transition: 'slide',           // zoom/slide
				swap_buttons: false            // enable to invert buttons
			},
			settings_modal: {
				layout: 'box',                 // box/bar
				// position: 'left',           // left/right
				transition: 'slide'            // zoom/slide
			}
		},
		current_lang: 'it',
		page_scripts: true,                        // default: false
		delay: 1500,                               // default: 0
		cookie_name: 'cookie_consent',             // default: 'cc_cookie'

		//autoclear_cookies: true,                 // default: false
		// mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
		// auto_language: '',                      // default: null; could also be 'browser' or 'document'
		// autorun: true,                          // default: true
		// force_consent: false,                   // default: false
		// hide_from_bots: false,                  // default: false
		// remove_cookie_tables: false             // default: false

		// cookie_expiration: 182,                 // default: 182 (days)
		// cookie_necessary_only_expiration: 182   // default: disabled
		// cookie_domain: location.hostname,       // default: current domain
		// cookie_path: '/',                       // default: root
		// cookie_same_site: 'Lax',                // default: 'Lax'
		// use_rfc_cookie: false,                  // default: false
		// revision: 0,                            // default: 0

		onFirstAction: function (user_preferences, cookie) {
			if (user_preferences.accepted_categories.indexOf("third_part") != -1) {
				location.reload();
			}
			//console.log('User accept type:', user_preferences.accept_type);
			//console.log('User accepted these categories', user_preferences.accepted_categories)
			//console.log('User reject these categories:', user_preferences.rejected_categories);
		},

		onAccept: function (cookie) {
			//console.log(cookie);
			// callback triggered on the first accept/reject action, and after each page load
		},

		onChange: function (cookie, changed_categories) {
			if (changed_categories.indexOf("third_part") != -1) {
				location.reload();
			}
			// callback triggered when user changes preferences after consent has already been given
		},

		languages: {
			'it': {
				consent_modal: {
					position: 'bottom center',
					title: 'Cookie policy',
					description: 'Questo sito utilizza i cookie per garantire il suo corretto funzionamento e una migliore esperienza di navigazione. Tutti i cookie, tranne quelli strettamente necessari al funzionamento del sito, richiedono un consenso esplicito da parte tua. <button type="button" data-cc="c-settings" class="cc-link">Visualizza le preferenze</button>',
					primary_btn: {
						text: 'Accetta tutti',
						role: 'accept_all'              // 'accept_selected' or 'accept_all'
					},
					secondary_btn: {
						text: 'Rifiuta tutti',
						role: 'accept_necessary'        // 'settings' or 'accept_necessary'
					}
				},
				settings_modal: {
					title: 'Preferenze sui cookie',
					save_settings_btn: 'Salva',
					accept_all_btn: 'Accetta tutti',
					reject_all_btn: 'Rifiuta tutti',
					close_btn_label: 'Chiudi',
					cookie_table_headers: [
						{ col1: 'Nome' },
						{ col2: 'Dominio' },
						{ col3: 'Durata' },
						{ col4: 'Descrizione' }
					],
					blocks: [
						{
							title: 'Uso dei cookie',
							description: 'Questo sito utilizza cookie essenziali per garantire il suo corretto funzionamento, cookie di terze parti per fornirti una migliore esperienza di navigazione e cookie di tracciamento per capire come interagisci con esso. I cookie di tracciamento e di terze parti verranno impostati solo dopo il tuo consenso.'
						}, {
							title: 'Cookie tecnici strettamente necessari per la navigazione',
							description: 'Questi cookie sono essenziali per il corretto funzionamento del sito web. Senza questi cookie la navigazione sarebbe impossibile.',
							toggle: {
								value: 'necessary',
								enabled: true,
								readonly: true          // cookie categories with readonly=true are all treated as "necessary cookies"
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: 'ASP.NET_SessionId',
									col2: location.host,
									col3: 'Scade con la sessione di navigazione',
									col4: 'Memorizza la sessione di navigazione corrente'
								},
								{
									col1: 'cookie_consent',
									col2: location.host,
									col3: '6 mesi',
									col4: 'Memorizza le preferenze sui cookie da te impostate'
								},
								{
									col1: 'Infocookie, cookieok',
									col2: location.host,
									col3: 'Nessuna scadenza',
									col4: 'Saranno utilizzati per memorizzare l\'avvenuta presentazione dell\'informativa sui cookie all\'utente'
								}
							]
						},
						{
							title: 'Cookie analitici',
							description: 'Questi cookie raccolgono informazioni su come utilizzi il sito web, quali pagine hai visitato e quali link hai cliccato. Tutti i dati sono resi anonimi e non possono essere utilizzati per identificarti.',
							toggle: {
								value: 'unnecessary',     // your cookie category
								enabled: false,
								readonly: false
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: '_ga',
									col2: 'google.com',
									col3: '12 Mesi',
									col4: 'Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.'
								},
								{
									col1: '_gat',
									col2: 'google.com',
									col3: '1 Giorno',
									col4: 'Utilizzato da Google Analytics per limitare la frequenza delle richieste'
								},
								{
									col1: '_gid',
									col2: 'google.com',
									col3: '1 Giorno',
									col4: 'Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.'
								},
								{
									col1: '__utma, __utma, __utmb, __utmc, __utmt, __utmv, __utmz',
									col2: 'google.com',
									col3: 'Nessuna scadenza',
									col4: 'Utilizzati da Google analytics per raccogliere informazioni statistiche sulle visite al sito in forma aggregata e anonima'
								}
							]
						},
						{
							title: 'Cookie di terze parti ',
							description: 'Questi cookie ci permettono di arricchire l\'esperienza di navigazione con contenuti multimediali provenienti da altre piattaforme.',
							toggle: {
								value: 'third_part',     // your cookie category
								enabled: false,
								readonly: false
							},
							cookie_table: [             // list of all expected cookies
								{
									col1: 'CONSENT',
									col2: '.youtube-nocookie.com',
									col3: 'Scade con la sessione di navigazione',
									col4: 'Dopo che l\'utente ha dato il proprio consenso, il cookie CONSENT salva l\'autorizzazione dell\'utente a inoltrare i dati a YouTube'
								},
								{
									col1: 'CONSENT',
									col2: 'google.com',
									col3: 'Nessuna scadenza',
									col4: 'Dopo che l\'utente ha dato il proprio consenso, il cookie CONSENT salva l\'autorizzazione dell\'utente a inoltrare i dati a GoogleMaps'
								},
								{
									col1: '__atuvc',
									col2: location.host,
									col3: 'Nessuna scadenza',
									col4: 'Social plugin - Necessari al funzionamento della banda di condivisione social AddThis'
								},
								{
									col1: '__atrfs',
									col2: location.host,
									col3: 'Nessuna scadenza',
									col4: 'Social plugin - Necessari al funzionamento della banda di condivisione social AddThis'
								},
								{
									col1: '__atuvs',
									col2: location.host,
									col3: 'Nessuna scadenza',
									col4: 'Social plugin - Necessari al funzionamento della banda di condivisione social AddThis'
								}
							]
						},
						{
							title: 'Maggiori informazioni',
							description: `Per maggiori informazioni sulla nostra cookie policy <a class="cc-link" href="${cookiePolicyUrl}">visita la pagina ad essa dedicata</a>`
						}
					]
				}
			}
		}
	});

	//console.log(cc.get('level'))

	if (cc.get('level')) {
		$("#cookie-tab").css("display", "flex").hide().fadeIn(400);
	}

	setTimeout(function () {
		var bodyCss = 'body{display:flex;align-items:center;justify-content:center}';
		var imgCss = 'img{max-width:100%;max-height:100%;margin-inline:auto}';
		var style = document.createElement("style");
		style.appendChild(document.createTextNode(imgCss));
		style.appendChild(document.createTextNode(bodyCss));
		$("iframe").each(function () {
			if (!this.contentDocument) return;
			this.contentDocument.head.appendChild(style);
		})
	}, 100);
})

//$(function () {

//	var getCookie = function (name) {
//		var nameEQ = name + "=";
//		var ca = document.cookie.split(';');
//		for (var i = 0; i < ca.length; i++) {
//			var c = ca[i];
//			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
//			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
//		}
//		return null;
//	};

//	function setCookie(name, value, days) {
//		var expires = "";
//		if (days) {
//			var date = new Date();
//			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
//			expires = "; expires=" + date.toGMTString();
//		}
//		document.cookie = name + "=" + value + expires + "; path=/";
//	}

//	$(document).on('click', '.close-cookie-directive', function () {
//		if (!$('.cookie-directive').length) return;
//		setCookie('cookiesDirective', 1, 365);
//		$('.cookie-directive').slideUp(300, function () {
//			$(this).remove();
//		});
//	});

//	$(window).on('scroll', function () {
//		if (!$('.cookie-directive').length) return;
//		setCookie('cookiesDirective', 1, 365);
//		$('.cookie-directive').slideUp(300, function () {
//			$(this).remove();
//		});
//	});

//	if (!getCookie('cookiesDirective')) {
//		$('.cookie-directive').fadeIn();
//	}
//});
